import { createContext } from "preact";
import { useState } from "preact/hooks";
import socket, {MessageTypes} from "../socket";

export const NavigationContext = createContext({});

export const withNavigation = (Component) => {
  return function NavigationComponent(props) {
    return <NavigationContext.Consumer>
      {ctx => <Component {...props} navigation={ctx} />}
    </NavigationContext.Consumer>;
  }
}

export const NavigationContextProvider = ({children}) => {
  const [route, setRoute] = useState({ path: "/" });
  const [appBarRight, setAppBarRight] = useState(null);

  const navigate = (nextRoute) => {
    setRoute(nextRoute);
    if (nextRoute && nextRoute.path === "/chat" && nextRoute.params.roomId) {
      socket.emit(MessageTypes.UPDATE_STATUS, {
        userData: {
          focusedRoom: nextRoute.params.roomId
        }
      });
    }
  }

  return <NavigationContext.Provider value={{
    route,
    appBarRight,
    setAppBarRight,
    navigate
  }}>{children}</NavigationContext.Provider>;
}



// WEBPACK FOOTER //
// ./contexts/NavigationContext.js